import React, { useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Spin, Table, message as waw } from 'antd';
import {
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { rulesGeneral, toRp } from '../../helpers/general_helper';
import { env } from '../../configs/EnvironmentConfig';
import { formatterNumber, parserNumber } from '../../helpers/input_format';
import axios from 'axios';
import dayjs from 'dayjs';


const { Option } = Select;
const RequestForm = (props, { callback }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const {
    message,
  } = props;

  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const onFinishRequest = async () => {
    const values = await form.validateFields();
    setFormData(values);
    values.total_price_all = Object.keys(values).length === 0 ? '-' : values?.items?.length > 0 ? values?.items?.reduce((a, b) => a + (parseInt(b.total_price) || 0), 0) : 0;
    setIsModalVisible(true);
  }

  const handleSubmit = async () => {
    try {
      setLoadingRequest(true);
      const values = await form.validateFields();

      values.total_price_all = Object.keys(values).length === 0
        ? '-'
        : values?.items?.length > 0
          ? values?.items?.reduce((a, b) => a + (parseInt(b.total_price) || 0), 0)
          : 0;

      const formData = new FormData();

      formData.append('applicant', values.applicant);
      formData.append('company', values.company);
      formData.append('division', values.division);
      formData.append('email_address', values.email_address);
      formData.append('jenis_kebutuhan', values.jenis_kebutuhan);
      formData.append('judul_pengajuan', values.judul_pengajuan);
      formData.append('keterangan', values.keterangan);
      formData.append('total_price_all', values.total_price_all);

      if (uploadedFile) {
        formData.append('document', uploadedFile);
      }

      values.items.forEach((item, index) => {
        formData.append(`items[${index}][item_permintaan]`, item.item_permintaan);
        formData.append(`items[${index}][jumlah_permintaan]`, item.jumlah_permintaan);
        formData.append(`items[${index}][price_per_unit]`, item.price_per_unit);
        formData.append(`items[${index}][request_date]`, item.request_date);
        formData.append(`items[${index}][satuan]`, item.satuan);
        formData.append(`items[${index}][total_price]`, item.total_price);
      });

      const response = await fetch(env.API + "/core/request-quotation", {
        method: 'POST',
        body: formData,
      });

      setLoadingRequest(false);

      if (response.status === 200) {
        waw.success('Data Berhasil Dikirim');
        form.resetFields();
        setUploadedFile(null);
        handleRemoveInput();
        setIsModalVisible(false);
      } else {
        const errorData = await response.json();
        console.error('Gagal Dikirim', response.statusText);
        waw.error(errorData?.message || 'Gagal mengirim data');
      }
    } catch (error) {
      setLoadingRequest(false);
      console.error('Error submitting data:', error);
      waw.error('Terjadi kesalahan saat mengirim data');
    }
  };

  const handlePricePerUnitChange = (value, index) => {
    const jumlahItem = form.getFieldsValue(['items', index, 'jumlah_permintaan']);
    console.log('handleprice change', jumlahItem.items, index)
    calculatePPNAndTotal(value, jumlahItem?.items[index]?.jumlah_permintaan, index);
  };

  const handleJumlahItemChange = (value, index) => {
    const hargaPerUnit = form.getFieldsValue(['items', index, 'price_per_unit']);
    console.log('handlejumlah item change', hargaPerUnit.items, index)
    calculatePPNAndTotal(hargaPerUnit?.items[index]?.price_per_unit, value, index);
  };

  const calculatePPNAndTotal = (price_per_unit, jumlah_permintaan, index) => {
    if (price_per_unit && jumlah_permintaan) {
      const hargaPerUnitFloat = parseFloat(price_per_unit);
      const jumlahItemInt = parseInt(jumlah_permintaan);
      const totalHarga = hargaPerUnitFloat * jumlahItemInt;
      form.setFieldsValue({
        items: [
          ...form.getFieldValue('items').map((item, idx) =>
            idx === index
              ? { ...item, total_price: totalHarga.toFixed(0) }
              : item
          )
        ]
      });
    } else {
      form.setFieldsValue({
        items: [
          ...form.getFieldValue('items').map((item, idx) =>
            idx === index ? { ...item, total_price: undefined } : item
          )
        ]
      });
    }
  };

  const columns = [
    {
      title: 'Item Permintaan',
      dataIndex: 'item_permintaan',
      key: 'item_permintaan'
    },
    {
      title: 'Jumlah Permintaan',
      dataIndex: 'jumlah_permintaan',
      key: 'jumlah_permintaan'
    },
    {
      title: 'Satuan',
      dataIndex: 'satuan',
      key: 'satuan'
    },
    {
      title: 'Harga Per Unit',
      dataIndex: 'price_per_unit',
      key: 'price_per_unit',
      render: (price_per_unit) => `Rp.${price_per_unit?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    },
    {
      title: 'Total Harga',
      dataIndex: 'total_price',
      key: 'total_price',
      render: (total_price) => `Rp.${total_price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
    },
    {
      title: 'Tanggal Pengiriman',
      dataIndex: 'request_date',
      key: 'request_date',
      render: (request_date) => formatDate(request_date),
    },
  ];

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const [datePicker, setDatePicker] = useState(null);
  const handleDateChange = (date, dateString) => {
    console.log('Selected Date:', dateString);
    setDatePicker(dateString)
  };

  const [quotationNumber, setQuotationNumber] = useState('');
  const [totalPrice, setTotalPrice] = useState(null);
  useEffect(() => {
    if (quotationNumber !== '') {
      fetchTotalPrice(quotationNumber);
    }
  }, [quotationNumber]);

  const fetchTotalPrice = async (no_quotation) => {
    try {
      const response = await fetch(env.API + `/core/price-quotation?no_quotation=${no_quotation}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setTotalPrice(data.data.total_price_all);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [inputCount, setInputCount] = useState(1);

  const handleAddInputItem = () => {
    if (inputCount < 15) {
      setInputCount(prevCount => prevCount + 1);
    } else {
      message.error('Anda telah mencapai batas maksimal 15 item.');
    }
  };

  const handleRemoveInput = () => {
    if (inputCount > 1) {
      setInputCount(prevCount => prevCount - 1);
      const values = form.getFieldValue('items');
      form.setFieldsValue({
        items: values.filter((_, i) => i !== inputCount - 1)
      });
    }
  };

  const [divisi, setDivisi] = useState([]);
  const getDivisi = async () => {
    try {
      const response = await axios.get(env.API + "/core/admin/divisi");
      setDivisi(response.data.data || []);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const [jenisKebutuhan, setKebutuhan] = useState([]);
  const getJenisKebutuhan = async () => {
    try {
      const response = await axios.get(env.API + "/core/admin/jenis-kebutuhan");
      setKebutuhan(response.data.data || []);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const [mitra, setMitra] = useState([]);
  const getMitra = async () => {
    try {
      const response = await axios.get(env.API + "/core/company/list");
      setMitra(response.data.data || []);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    getJenisKebutuhan();
    getDivisi();
    getMitra();
  }, []);
  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        name="request-form"
        onFinish={onFinishRequest}
        autoComplete="off"
      >
        <div className=''>
          <div className='header-from-input-wraper-content'>
            <div className=''>
              <div className='header-from-input-wraper-title'>
                <div className='header-form-wraper-border-inline'>
                  <div className='header-form-wraper-border'>
                    <div className='header-from-input-wraper-inline'>
                      <div className=''>
                        <h1 style={{ fontSize: '18px', fontWeight: '600', color: 'black' }}>Quotation Request</h1>
                        <p style={{ color: '#6F6C6C', fontSize: '13px' }}>Berikut ini dapat diinputkan data Nomor Pengajuan Pembelian dan Juga Harga kepada koperasi toyota.</p>
                      </div>
                      <Form.Item
                        hasFeedback
                        label="Judul Pengajuan"
                        name="judul_pengajuan"
                        rules={rulesGeneral()}
                      >
                        <Input
                          placeholder="Masukan Judul"
                        />
                      </Form.Item>
                      <Row gutter={[16, 16]} justify="start" style={{ marginTop: '30px' }}>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            hasFeedback
                            label="Pemohon"
                            name="applicant"
                            rules={rulesGeneral()}
                          >
                            <Input
                              placeholder="Masukan Nama Pemohon"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            hasFeedback
                            label="Alamat Email"
                            name="email_address"
                            rules={rulesGeneral()}
                          >
                            <Input
                              placeholder="Masukan Alamat Email"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            hasFeedback
                            name="division"
                            label="Divisi"
                            rules={rulesGeneral()}
                          >
                            <Select style={{ width: "100%" }} placeholder="Pilih Salah Satu">
                              <Option value="" disabled>
                                -- Pilih --
                              </Option>
                              {divisi.map((nama_divisi) => {
                                return (
                                  <Option value={nama_divisi.id}>
                                    {nama_divisi.nama_divisi}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            hasFeedback
                            name="jenis_kebutuhan"
                            label="Jenis Kebutuhan"
                            rules={rulesGeneral()}
                          >
                            <Select style={{ width: "100%" }} placeholder="Pilih Salah Satu">
                              <Option value="" disabled>
                                -- Pilih --
                              </Option>
                              {jenisKebutuhan.map((jenis_kebutuhan) => {
                                return (
                                  <Option value={jenis_kebutuhan.id}>
                                    {jenis_kebutuhan.nama_jenis_kebutuhan}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            hasFeedback
                            label="Nama Perusahaan Mitra"
                            name="company"
                            rules={rulesGeneral()}
                          >
                            <Select style={{ width: "100%" }}
                              placeholder="Pilih Salah Satu"
                              showSearch
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option?.children.toLowerCase().includes(input.toLowerCase())
                              }
                            >
                              <Option value="" disabled>
                                -- Pilih --
                              </Option>
                              {mitra.map((nama_company) => {
                                return (
                                  <Option value={nama_company.id}>
                                    {nama_company.nama_company}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <div className='header-from-input-wraper-line-loop mt-3'></div>
                      {[...Array(inputCount)].map((_, index) => (
                        <>
                          <div style={{ display: 'flex' }}>
                            <h1 style={{ fontSize: '13px', marginTop: '28px', marginLeft: '0px' }}>{`Item ${index + 1}`}</h1>
                          </div>
                          <Row gutter={[16, 16]} justify="start" style={{ marginTop: '10px' }}>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Item Kebutuhan</h5>
                              <Form.Item
                                hasFeedback
                                name={['items', index, 'item_permintaan']}
                                rules={rulesGeneral()}
                              >
                                <Input
                                  placeholder="Masukan Item Kebutuhan"
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Jumlah</h5>
                              <Form.Item
                                hasFeedback
                                name={['items', index, 'jumlah_permintaan']}
                                rules={[
                                  {
                                    required: true,
                                    message: "Jumlah permintaan tidak boleh kosong",
                                  },
                                  {
                                    pattern: /^[0-9]*$/,
                                    message: "Jumlah permintaan hanya boleh berisi angka",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Masukan Jumlah"
                                  onChange={(e) => handleJumlahItemChange(e.target.value, index)}
                                  onKeyPress={(e) => {
                                    const charCode = e.which ? e.which : e.keyCode;
                                    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                      e.preventDefault();
                                      waw.error('Hanya diperbolehkan memasukkan angka!');
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Satuan</h5>
                              <Form.Item
                                hasFeedback
                                name={['items', index, 'satuan']}
                                rules={rulesGeneral()}
                              >
                                <Select style={{ width: "100%" }} placeholder="Masukan Satuan">
                                  <Option value="" disabled>
                                    -- Pilih --
                                  </Option>
                                  <Option value="PCS">PCS</Option>
                                  <Option value="UNIT">UNIT</Option>
                                  <Option value="PACK">PACK</Option>
                                  <Option value="LOT">LOT</Option>
                                  <Option value="AU">AU</Option>
                                  <Option value="TBG">TBG</Option>
                                  <Option value="MANMONTH (MM)">MANMONTH (MM)</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Harga Per Unit</h5>
                              <Form.Item
                                hasFeedback
                                name={['items', index, 'price_per_unit']}
                                rules={[
                                  {
                                    required: true,
                                    message: "Harga Per Unit tidak boleh kosong",
                                  },
                                  {
                                    pattern: /^[0-9]*$/,
                                    message: "Harga Per Unit hanya boleh berisi angka",
                                  },
                                ]}
                                initialValue={''}
                              >
                                <InputNumber
                                  style={{ width: '100%' }}
                                  controls={false}
                                  {...props}
                                  formatter={(value) => formatterNumber(value)}
                                  parser={(value) => parserNumber(value)}
                                  onChange={(value) => handlePricePerUnitChange(value ? value : [], index)}
                                  placeholder="Masukan Harga Per Unit"
                                  onKeyPress={(e) => {
                                    const charCode = e.which ? e.which : e.keyCode;
                                    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                                      e.preventDefault();
                                      waw.error('Hanya diperbolehkan memasukkan angka!');
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Total Harga</h5>
                              <Form.Item
                                hasFeedback
                                placeholder="Input Total Harga"
                                name={['items', index, 'total_price']}
                                rules={rulesGeneral()}
                              >
                                <InputNumber
                                  style={{ width: '100%' }}
                                  {...props}
                                  formatter={(value) => formatterNumber(value)}
                                  parser={(value) => parserNumber(value)}
                                  disabled
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8}>
                              <h5 style={{ fontWeight: "600", fontSize: "13px" }}>Tanggal Pengiriman</h5>
                              <Form.Item
                                name={['items', index, 'request_date']}
                                rules={[
                                  {
                                    required: true,
                                    message: "Tanggal pengiriman tidak boleh kosong",
                                  },
                                ]}
                                initialValue={datePicker ? dayjs(datePicker, 'YYYY-MM-DD') : ''}
                              >
                                <DatePicker
                                  picker="date"
                                  onChange={handleDateChange}
                                  placeholder='Pilih Tanggal'
                                  format="YYYY-MM-DD"
                                  style={{ width: "100%" }}
                                  disabledDate={disabledDate}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      ))}
                      <Form.Item>
                        <Button type="primary" onClick={handleAddInputItem} style={{ marginRight: '10px', backgroundColor: 'transparent', color: '#03753F' }}>+   TAMBAH ITEM</Button>
                        <Button type="danger" onClick={handleRemoveInput} disabled={inputCount === 1}>HAPUS ITEM</Button>
                        <div style={{ padding: '20px' }}></div>
                      </Form.Item>
                      <div className='header-from-input-wraper-line-loop mt-3'></div>
                      <div className='mt-4 mb-4'>
                        <Form.Item
                          label="Upload Dokumen"
                          name="dokumen"
                        >
                          <Input
                            placeholder="Pilih berkas"
                            readOnly
                            suffix={<UploadOutlined style={{ fontSize: '18px', color: '#8c8c8c' }} />}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              const input = document.createElement('input');
                              input.type = 'file';
                              input.accept = '.pdf';
                              input.onchange = (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  const isPDF = file.type === 'application/pdf';
                                  const isLt2M = file.size / 1024 / 1024 < 2.6;

                                  if (!isPDF) {
                                    waw.error('File harus berformat PDF!');
                                    return;
                                  }
                                  if (!isLt2M) {
                                    waw.error('File tidak boleh lebih dari 2.6MB!');
                                    return;
                                  }

                                  form.setFieldsValue({ dokumen: file.name });
                                  setUploadedFile(file);
                                  waw.success(`File ${file.name} berhasil dipilih`);
                                }
                              };
                              input.click();
                            }}
                          />
                        </Form.Item>
                        <p style={{
                          fontSize: '12px',
                          color: '#8c8c8c',
                          marginTop: '-16px',
                          marginBottom: '24px'
                        }}>
                          Supported format : pdf with max 2.5mb
                        </p>

                        <Form.Item
                          label="Keterangan"
                          name="keterangan"
                          rules={[
                            { required: true, message: 'Tidak Boleh Kosong' },
                            {
                              validator(_, value) {
                                if (value && value.trim().length === 0) {
                                  return Promise.reject(new Error('Jika tidak ada keterangan, minimal isi -'));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          className="textarea-single-count"
                        >
                          <Input.TextArea
                            placeholder="Input Keterangan"
                            rows={4}
                            style={{ resize: 'none' }}
                            showCount
                            maxLength={500}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=''>
          <div className='footer-input-submit-wraper'>
            <div className='footer-input-submit-wraper-button'>
              <Row gutter={[16, 16]} justify="space-between" align="top">
                <Col xs={24} sm={12} lg={8}>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <button
                    className='button-send-request-wraper'
                    style={{ cursor: 'pointer' }}
                    htmlType="submit"
                  >KIRIM PENGAJUAN</button>

                  <Modal
                    closable={false}
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    width={900}
                    footer={null}
                  >
                    <>
                      <div>
                        <h1 className='modal-text-action-wraper' style={{ textAlign: 'center' }}>Konfirmasi Pengajuan</h1>
                        <h1 className='modal-text-action-wraper' style={{ textAlign: 'center', fontSize: '14px', fontWeight: '400', marginBottom: '25px' }}>Jika Anda memilih Kirim Pengajuan akan dikirim. atau Klik edit untuk mengubah data pengajuan.</h1>
                      </div>
                      <Table
                        dataSource={formData?.items}
                        columns={columns}
                        pagination={false}
                      />
                      <div style={{ marginLeft: 'auto' }}>
                        <h1 style={{ fontWeight: '600', fontSize: '16px', marginTop: '10px' }}>Total : {`Rp.${toRp(formData.total_price_all)}`}</h1>
                      </div>
                      <Row gutter={[16, 16]} justify="space-between" align="top">
                        <Col xs={24} sm={12} lg={8}>
                          <div style={{ padding: '15px', textAlign: 'center' }}>
                            <button onClick={handleCancel} className='button-save-draft-wraper' style={{ cursor: 'pointer' }}>EDIT REQUEST</button>
                          </div>
                        </Col>
                        <Col xs={24} sm={12} lg={8}>
                          <div style={{ padding: '15px', textAlign: 'center' }}>
                            <button key='confirm' onClick={handleSubmit} disabled={loading} className='button-modal-sendreq-wraper' style={{ cursor: 'pointer' }}>
                              {loadingRequest ? (
                                <Spin
                                  indicator={
                                    <LoadingOutlined
                                      style={{ fontSize: 24, color: "white" }}
                                      spin
                                    />
                                  }
                                />
                              ) : (
                                "KIRIM REQUEST"
                              )}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </>
                  </Modal>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Form>
    </>
  )
}

export default RequestForm
